export const FILE_EXTENSIONS = {
  video: [
    'mp4',
    'mov',
    'avi',
    'wmv',
    'flv',
    'mkv',
    'webm',
    'm4v',
    'mpg',
    '3gp',
  ],

  audio: ['mp3', 'wav', 'aac', 'ogg', 'flac', 'm4a', 'wma', 'amr'],

  image: [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'tif',
    'tiff',
    'svg',
    'ico',
    'heic',
    'raw',
    'psd',
  ],

  pdf: ['pdf'],

  excel: ['xls', 'xlsx', 'ods'],

  csv: ['csv'],

  text: ['txt', 'md', 'log', 'rtf'],

  word: ['doc', 'docx', 'odt'],

  ppt: ['ppt', 'pptx', 'odp'],

  zip: ['zip', 'rar', 'tar', 'gz', '7z', 'iso', 'cab'],

  code: ['html', 'htm', 'js', 'json', 'xml', 'yaml', 'yml'],

  design: ['ai', 'eps', 'indd', 'dwg', 'dxf'],
};
